import React, { useEffect } from "react";
import { View, Animated } from "react-native";
import { Dimensions } from "react-native";

const { width } = Dimensions.get("window");

const SkeletonLoader = ({ children }: { children: React.ReactNode }) => {
  const animatedValue = new Animated.Value(0);

  useEffect(() => {
    Animated.loop(
      Animated.sequence([
        Animated.timing(animatedValue, {
          toValue: 1,
          duration: 1000,
          useNativeDriver: false,
        }),
        Animated.timing(animatedValue, {
          toValue: 0,
          duration: 1000,
          useNativeDriver: false,
        }),
      ])
    ).start();
  }, []);

  const translateX = animatedValue.interpolate({
    inputRange: [0, 1],
    outputRange: [-width, width],
  });

  return (
    <View className="">
      <Animated.View
        className="absolute inset-0 bg-gray-100/50"
        style={{
          transform: [{ translateX }],
        }}
      />
      {children}
    </View>
  );
};

export const SkeletonBox = ({ className = "" }) => (
  <View className={`rounded bg-gray-200 ${className}`} />
);

export const SkeletonCircle = ({ size = 10, className = "" }) => (
  <View
    className={`rounded-full bg-gray-200 ${className}`}
    style={{
      height: size,
      width: size,
    }}
  />
);

export const SkeletonText = ({ lines = 1, className = "" }) => (
  <View className={`space-y-2 ${className}`}>
    {Array(lines)
      .fill(0)
      .map((_, index) => (
        <View
          key={index}
          className={`h-3 bg-gray-200 rounded ${
            index === lines - 1 ? "w-3/4" : "w-full"
          }`}
        />
      ))}
  </View>
);

export default SkeletonLoader;
